<template>
  <v-layout>
    <v-flex
      xs12
      md12
    >
      <material-card
        color="secundary"
        text=""
      >
        <Titulo :empresa="empresa"/>
        <Menu :empresa="empresa"/>
      </material-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import Menu from './components/Menu'
import Titulo from './components/Titulo'

export default {
  components: {
    Menu,
    Titulo
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    empresa: Object
  },
  data: () => ({
    logo: null
  }),
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas'])
  }
}
</script>
